import { cn } from "@productlane/lib/src/browser"

export function ProgressBar({
	percentage,
	className,
	fillClassName,
}: {
	percentage: number
	className?: string
	fillClassName?: string
}) {
	return (
		<div
			className={cn(
				"h-1 w-full overflow-hidden rounded-full bg-gray-200 transition-all dark:bg-gray-800",
				className,
			)}
		>
			<div
				className={cn(
					"relative h-full bg-green-500 transition-all duration-500",
					fillClassName,
				)}
				style={{
					width: `${percentage}%`,
				}}
			></div>
		</div>
	)
}
